import React, { useState } from 'react'

import * as S from './styles'
import { Testimonial } from '@/components'
import { CasePagination } from '@/components/casePagination'
import { CaseMapper } from '@/service/api/home'

export type CasesContainerProps = {
  /**
   * The data of the cases
   *
   * @example
   * ```tsx
   * const casesData = [{
   *  ...
   * }]
   *
   * <CasesContainer caseData={casesData} />
   * ```
   */
  data: CaseMapper

  /**
   * The darkMode condition to set dark color
   *
   * @example
   * ```tsx
   * <CasesContainer darkMode={true} />
   * ```
   */
  darkMode?: boolean
}

export const CasesContainer: React.FC<CasesContainerProps> = ({
  data,
  darkMode,
}) => {
  const [caseIndex, setCaseIndex] = useState(0)

  if (!data.casesData.length || data.hideDepositions) return null

  const cases = data.casesData[caseIndex]
  return (
    <S.FlexContainerCases padding="0">
      <S.CasesContainer>
        <div className="testimonial-container">
          <Testimonial
            authorPicture={cases?.authorAvatar}
            authorName={cases?.authorName}
            authorRole={cases?.authorRole}
            description={cases?.description}
            darkMode={darkMode}
          />
          <div className="pagination-container">
            <CasePagination
              length={data.casesData.length}
              setIndex={setCaseIndex}
              index={caseIndex}
              slug={cases.slug}
            />
          </div>
        </div>
      </S.CasesContainer>
    </S.FlexContainerCases>
  )
}
